<template>
  <div class="waiting">
    <div class="content">
      <div class="image">
        <img src="@/assets/iconImage/check.svg" alt="" />
      </div>
      <p>Data anda <b>Berhasil</b> diinput,</p>
      Admin Akan Memverifikasi Data Anda
      <div class="wrap-contact">
        untuk info lebih lanjut hubungi customer service berikut
        <div class="contact">
          <div>
            <img src="../assets/call.png" alt="telepone" class="contact-icon" />
            <span>+6221 5761461</span>
          </div>
          <div>
            <img src="../assets/envelope.png" alt="email" class="contact-icon" />
            <span>info@abicommodity.co.id</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.waiting {
  position: relative;
  height: 100%;
}

.content {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #1e354a;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  background: #ffffff;
  border-radius: 5px;
  width: 53%;
  margin: 9% auto 0;
  padding: 25px;
  position: relative;
}

.content p {
  font-size: 30px;
  color: #1f354a;
  margin: -50px 0 0 0;
  font-weight: bold;
}

b {
  color: #c59733;
}

.image {
  text-align: center;
  position: relative;
  top: -77px;
}

.image img {
  width: 25%;
}

.logo-pos {
  width: 110px;
  margin: 45px 20px 40px 0;
  /* height: 222.5px; */
}

.logo-abi {
  width: 68px;
  margin: 15px 20px 0;
}

.wrap-contact {
  margin: 30px 0;
  font-size: 14px;
}

.contact {
  display: flex;
  margin-top: 10px;
  font-size: 13px;
  justify-content: space-between;
}

.contact-icon {
  width: 20px;
  margin-right: 15px;
}

@media (max-width: 720px) {
  .content {
    width: 90%;
    text-align: center;
    margin: 5rem auto;
  }
}
</style>
